import { Button, Card, Flex, Text } from '@servicetitan/anvil2';
import Launch from '@servicetitan/anvil2/assets/icons/material/round/launch.svg';
import checkmarkSuccess from './checkmark-success.svg';
import { formatCurrency } from '@servicetitan/financing-utils-shared';

interface PrequalApprovedScreenProps {
    approvedAmount: number;
    onApplyNow: () => void;
}

export const PrequalApprovedScreen = ({
    approvedAmount,
    onApplyNow,
}: PrequalApprovedScreenProps) => {
    const formattedAmount = formatCurrency(approvedAmount);

    return (
        <Flex direction="column" gap="6" style={{ padding: '16px 0' }}>
            <Flex direction="column" gap="6" alignItems="center" style={{ textAlign: 'center' }}>
                {/* Success icon with decorative elements */}
                <img
                    src={checkmarkSuccess}
                    alt="Pre-qualification approved"
                    style={{ marginTop: '16px' }}
                />

                {/* Title */}
                <Text variant="headline" el="h2">
                    You've been prequalified. Only a few more steps to go!
                </Text>

                {/* Credit line display */}
                <Card flexDirection="column" gap="2" alignItems="center" style={{ width: '100%' }}>
                    <Text variant="body" size="small" color="subdued">
                        UP TO
                    </Text>
                    <Text variant="body" size="xlarge" style={{ fontWeight: 'bold' }}>
                        {formattedAmount}
                    </Text>
                    <Text variant="body" size="small" color="subdued">
                        available credit line
                    </Text>
                </Card>
            </Flex>
            <Flex direction="column" gap="2" alignItems="flex-start" style={{ padding: 24 }}>
                {/* Disclaimer text */}
                <Text variant="body" size="small" color="subdued" style={{ textAlign: 'left' }}>
                    Final credit approval will be based on your ability to pay and identify
                    verification. Continuing with this process will result in a hard pull on your
                    credit.
                </Text>

                {/* Disclaimer about using prequalification data */}
                <Text variant="body" size="small" color="subdued" style={{ textAlign: 'left' }}>
                    By selecting Apply Now the information provided during the prequalification will
                    be used as part of your application.
                </Text>
            </Flex>
            {/* Apply Now button */}
            <Button
                appearance="primary"
                onClick={onApplyNow}
                icon={Launch}
                style={{ marginTop: 'auto', width: '100%' }}
            >
                Apply Now
            </Button>
        </Flex>
    );
};
